import { last } from 'lodash';
import { createRef, useEffect } from 'react';
import { closeAppPopovers } from './withPopover';

const getFocusableElements = (ref = {}) => {
  if (!ref.current) return [];

  return [...ref.current.querySelectorAll(
    '[tabindex], a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select',
  )]
    .filter(el => el.getAttribute('tabindex') !== '-1');
};

let refs = [];

export const useTrappedFocus = () => {
  const ref = createRef();
  refs.push(ref);

  useEffect(() => {
    const handleTabKey = e => {
      if (!['Tab', 9].includes(e.key) || !ref.current || last(refs) !== ref) return;
      closeAppPopovers();
      const focusableElements = getFocusableElements(ref);

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      if (
        (!e.shiftKey && document.activeElement === lastElement)
        || !focusableElements.includes(document.activeElement)
      ) {
        e.preventDefault();
        firstElement.focus();
        return;
      }

      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
    };

    if (ref.current && !ref.current.contains(document.activeElement)) setTimeout(() => getFocusableElements(ref)[0].focus());
    document.addEventListener('keydown', handleTabKey);

    return () => {
      refs = refs.filter(r => r !== ref);
      document.removeEventListener('keydown', handleTabKey);
    };
  });

  return ref;
};
